import React, {useEffect, useState} from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import CurrencyFormat from 'react-currency-format';
import {Link, useHistory, useRouteMatch} from 'react-router-dom';
import {Badge, Box, CircularProgress, Container, Tabs} from '@material-ui/core';
import NumericInput from 'react-numeric-input';
import AppButton from '../components/AppButton';
import ImageGallery from 'react-image-gallery';
import {makeStyles} from '@material-ui/core/styles';
import {useDispatch, useSelector} from 'react-redux';
import {addNotification, addToShoppingCart, getProductById} from '../redux/actions';
import {getPicture} from '../modules/imageHandler';
import ItemProduct from '../components/makeComponents/components/ItemProduct';
import {SELECTOR_CONFIGS_UNITS} from '../redux/selectors/configs';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import {useGA4React} from 'ga-4-react';
import Helmet from '../components/Helmet';
import numeral from 'numeral';
import Divider from '@material-ui/core/Divider';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import {SELECTOR_CATEGORIES_TREE_WITH_ID} from '../redux/selectors/categories';
import ReactPixel from 'react-facebook-pixel';
import api from '../services/api';
import ProductReviews from './ProductReviews';
import clsx from 'clsx';
import {FavoriteBorder, FavoriteTwoTone} from '@material-ui/icons';
import ModalSubscribeUserProduct from '../components/ModalSubscribeUserProduct';

require('react-image-gallery/styles/css/image-gallery.css');

const useStyles = makeStyles((theme) => ({
  title: {
    fontSize: '1.4rem',
    fontWeight: 700,
    textTransform: 'capitalize',
    lineHeight: 1.3,
    marginBottom: theme.spacing(1),
  },
  subtitle: {
    fontSize: '.8rem',
    fontWeight: 400,
    marginBottom: theme.spacing(2),
    color: theme.palette.text.hint,
  },
  price: {
    fontWeight: 700,
    fontSize: '1.8rem',
  },
  quantity: {
    fontWeight: 500,
    fontSize: '1.1rem',
    marginBottom: theme.spacing(2),
  },
  shipments: {
    fontWeight: 400,
    fontSize: '1.15rem',
    marginBottom: theme.spacing(0.2),
  },
  shipmentsBold: {
    fontWeight: 'bold',
    fontSize: '1.15rem',
    marginBottom: theme.spacing(0.2),
  },
  helpText: {
    fontWeight: 700,
    fontSize: '.9rem',
    color: '#5F5F5F',
    marginBottom: theme.spacing(1),
  },
  text: {
    fontSize: '.95rem',
    whiteSpace: 'pre-line',
  },
  image: {
    margin: '0 auto',
    display: 'block',
    height: 270,
  },
  close: {
    position: 'absolute',
    top: 20,
    right: 30,
    [theme.breakpoints.down('sm')]: {
      top: 10,
      right: 20,
    },
  },
  actions: {
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  addedProductButton: {
    // marginLeft: theme.spacing(3),
    [theme.breakpoints.down('sm')]: {
      marginLeft: 0,
      marginTop: theme.spacing(0),
    },
  },
  imageGalleryWrapper: {
    position: 'relative',
    '& .image-gallery-image': {
      height: '460px!important',
      position: 'relative',
    },
    '& .image-gallery-thumbnail-image': {
      width: 'auto!important',
      maxHeight: '50px!important',
    },
    '& .image-gallery-slides': {
       padding: '0px 40px',
    },
  },
  opacityBackgroundWrapper: {
    position: 'absolute',
    top: 10,
    right: 30,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: 100,
    height: 100,
    borderRadius: '100%',
    backgroundColor: '#1374eea8',
  },
  tagSale: {
    fontSize: 14,
    color: 'white',
    position: 'absolute',
    padding: '4px 8px',
    top: 2,
    left: 2,
    background: '#0A588A',
    borderRadius: 4,
    fontWeight: 'bold',
    textTransform: 'uppercase',
    zIndex: 100,
  },
  tagOffert: {
    fontSize: 14,
    color: 'white',
    position: 'absolute',
    padding: '4px 8px',
    top: 2,
    left: 2,
    background: '#EF1719',
    borderRadius: 4,
    fontWeight: 'bold',
    textTransform: 'uppercase',
    zIndex: 100,
  },
  rootTabs: {
    // maxWidth: 930,
  },
  agotado: {
    '& img': {
      opacity: '0.3',
    },
  },
  tabSelected: {
    background: 'white',
    transition: '.14s all',
    border: `1px solid ${theme.palette.grey.light}`,
    fontWeight: 400,
    '&.Mui-selected': {
      background: theme.palette.primary.main,
      color: 'white',
      borderColor: theme.palette.primary.main,
    },
    '&:not(:last-child)': {
      borderRight: 0,
    },
  },
}));

const TabPanel = (props) => {
  const {children, value, index, ...other} = props;
  if (value !== index) return <></>;
  return (
    <div
      role="tabpanel"
      style={{boxSizing: 'border-box', width: '100%', padding: 0}}
      hidden={value !== index}
      id={`product-tabpanel-${index}`}
      {...other}
    >
      {children}
    </div>
  );
};

const ProductsInterest = ({categoryId, currentProductId}) => {
  const [categories, setCategories] = useState([]);

  const getProductsByCategoryId = async (val) => {
    await api.products
      .find({
        query: {
          category_id: val,
          id: {$ne: currentProductId},
          status: 'active',
          $sort: {name: 1},
          $limit: 50,
          quantity: {$gt: 0},
        },
      })
      .then(({data}) => {
        const shuffledData = data.sort(() => 0.5 - Math.random()).slice(0, 4);
        setCategories(shuffledData);
      })
      .catch(() => undefined);
  };

  useEffect(() => {
    if (categoryId) {
      getProductsByCategoryId(categoryId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [categoryId]);

  return (
    <Grid container spacing={1}>
      {categories.map((product, i) => (
        <Grid key={i} item xs={6} md={3}>
          <ItemProduct data={product} />
        </Grid>
      ))}
    </Grid>
  );
};

function Product() {
  const match = useRouteMatch('/p-:productId-:productName');
  const history = useHistory();

  const productId = match ? match.params.productId : 0;
  const user = useSelector((state) => state.auth.user);
  const isAuth = useSelector((state) => state.auth.isAuthenticate);
  const product = useSelector((state) => state.products.products[productId]);
  const [activeTab, setActiveTab] = useState(0);
  const categories = useSelector(SELECTOR_CATEGORIES_TREE_WITH_ID(product?.category.id));
  const units = useSelector(SELECTOR_CONFIGS_UNITS);
  const [loading, setLoading] = useState(true);
  const [_404, set404] = useState(false);
  const [openModalSubscribe, setOpenModalSubscribe] = useState(false);

  const classes = useStyles();
  const dispatch = useDispatch();

  const isMobil = useMediaQuery('(max-width:960px)');
  const ga = useGA4React();

  const [quantity, setQuantity] = useState(1);

  const handleAddedShoppingCart = () => {
    !!ga &&
      ga.gtag('event', 'add_to_cart', {
        currency: 'COP',
        value: getPrice(
          product?.discount_price_whit_tax || product?.price_with_tax,
          product?.price_list?.product_price_list,
        ),
        items: [
          {
            item_id: product?.id,
            item_name: product?.name,
            quantity,
            price: getPrice(
              product?.discount_price_whit_tax || product?.price_with_tax,
              product?.price_list?.product_price_list,
            ),
          },
        ],
      });
    ReactPixel.track('AddToCart', {
      content_ids: [product.id.toString()],
      content_name: product.name,
      content_type: 'product',
      contents: [{id: product.id.toString(), quantity: quantity}],
      currency: 'COP',
      value: getPrice(
        product.discount_price_whit_tax || product.price_with_tax,
        product.price_list?.product_price_list,
      ),
    });
    dispatch(addToShoppingCart({productId: Number(productId), quantity}));
  };

  const handleAddFavorite = async () => {
    if (product.is_favorite) return;
    await api.favorites
      .create({type: 'product', type_id: product.id})
      .then(() => {
        dispatch(getProductById(productId))
          .catch((err) => {
            set404(true);
          })
          .finally(() => setLoading(false));
      })
      .catch(() => {
        dispatch(addNotification('No ha sido posible completar la acción', 'error'));
      });
  };

  const handleOpenSubscribeProduct = async () => {
    setOpenModalSubscribe(!openModalSubscribe);
  };

  useEffect(() => {
    // noinspection JSUnresolvedVariable
    if (productId)
      dispatch(getProductById(productId))
        .catch((err) => {
          set404(true);
        })
        .finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productId]);

  const handleOnChangeNumeric = (value) => {
    setQuantity(value);
  };

  const _getImages = () => {
    if (!product?.media) {
      return [];
    }
    return product?.media.map((item) => ({
      original: getPicture(item.path, 1000, 1000),
      thumbnail: getPicture(item.path, 100, 100),
    }));
  };

  const images = _getImages();

  const getPrice = (price, pricelist = []) => {
    let priceListID = user?.company?.price_list_id;

    if (priceListID && isAuth && pricelist) {
      let currentPrice = (
        Array.isArray(pricelist) ? pricelist : pricelist.price_list_id ? [pricelist] : Object.values(pricelist)
      ).find((item) => item.price_list_id === priceListID);
      return currentPrice?.price_with_tax || currentPrice?.price || price;
    }

    return price;
  };

  if (loading) {
    return (
      <Container style={{height: 'calc(100vh - 130px)'}}>
        <Grid container direction="column" style={{height: '100%'}} justifyContent="center" alignItems="center">
          <Box display="flex" my={5} justifyContent="center">
            <CircularProgress />
          </Box>
        </Grid>
      </Container>
    );
  }

  if (_404) {
    return (
      <Container style={{height: 'calc(100vh - 130px)'}}>
        <Grid container direction="column" style={{height: '100%'}} justifyContent="center" alignItems="center">
          <Box display="flex" my={5} justifyContent="center">
            <Typography variant="h2">404</Typography>
          </Box>
          <Box display="flex" my={5} justifyContent="center">
            <Typography variant="h4">Producto no encontrado :(</Typography>
          </Box>
        </Grid>
      </Container>
    );
  }

  return (
    <Container style={{marginTop: 30, marginBottom: 30}}>
      <Helmet
        title={product?.name || ''}
        description={product?.description || product?.name || ''}
        canonical={product?.slug || ''}
        og={{
          url: window.location.href,
          title: product?.name || '',
          description: product?.description || product?.name || '',
          image: images?.[0]?.original || '',
        }}
      />
      <Grid container>
        {/* <Grid item xs={12}>
          <div style={{ justifyContent:"center", alignItems:"center", flex: 1 , backgroundColor:"#fffeec", padding: 16, marginBottom:10}}>
          <Typography
            color="textPrimary"
            style={{textAlign: "center"}}
            >
              Para compras realizadas en los días 17, 18, 19, 20 y 21 de febrero los despachos de los pedidos se realizarán a partir del 22 de febrero por motivo de Carnaval de Barranquilla en nuestra sede principal ubicada en esta ciudad.
          </Typography>
          </div>
        </Grid> */}
        <Grid item xs={12}>
          <div style={{marginBottom: 30}}>
            <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
              {categories.map((it, i) => (
                <Typography
                  key={i}
                  color="textPrimary"
                  onClick={() => {
                    history.push(`/${it.slug}`);
                  }}
                  style={{cursor: 'pointer'}}
                >
                  {it.name}
                </Typography>
              ))}
            </Breadcrumbs>
          </div>
        </Grid>
        {!isMobil && (
          <Grid item xs={12} md={6} style={{position: 'relative'}}>
            {!!product?.discount_price_whit_tax && product?.quantity > 0 && (
              <div className={classes.tagOffert}>Oferta</div>
            )}
            <div className={clsx(classes.imageGalleryWrapper, product?.quantity <= 0 ? classes.agotado : '')}>
              <ImageGallery showNav={false} showPlayButton={false} items={images} />
              {product?.quantity <= 0 && (
                <div className={classes.opacityBackgroundWrapper}>
                  <span style={{color: 'white', fontSize: '16px'}}>AGOTADO</span>
                </div>
              )}
            </div>
          </Grid>
        )}
        <Grid item xs={12} md={6}>
          <Typography variant="h1" className={classes.title}>
            {product?.name}
            {product?.unit_measure !== 'UND' && (
              <span>
                {' - '}
                {units[product?.unit_measure] ? units[product?.unit_measure] : product?.unit_measure}
                {' x '}
                {product?.quantity_per_unit_measure} {product?.quantity_per_unit_measure > 1 ? 'unidades' : 'unidad'}
              </span>
            )}
          </Typography>
          <Typography variant="h6" className={classes.subtitle}>
            Referencia: {product?.code}
          </Typography>
          <Box display="flex">
            <Typography variant="h6" className={classes.subtitle}>
              Fabricante:
              <Link
                to={`/b?configure%5Bpage%5D=1&configure%5Bfacets%5D%5B0%5D=category_path_ids&configure%5BfacetFilters%5D%5B0%5D=category_path_ids%3A&configure%5BnumericFilters%5D%5B0%5D=quantity%20>%3D%201&hierarchicalMenu%5Bcategories.lvl0%5D=&refinementList%5Bbrand.name%5D%5B0%5D=${product?.brand?.name}`}
              >
                {product?.brand?.name}
              </Link>
            </Typography>
          </Box>
          {isMobil && (
            <div>
              <div className={classes.imageGalleryWrapper} style={{position: 'relative'}}>
                {!!product?.discount_price_whit_tax && product?.quantity > 0 && (
                  <div className={classes.tagOffert}>Oferta</div>
                )}
                <ImageGallery showNav={false} showPlayButton={false} items={images} />
                {product?.quantity <= 0 && (
                  <div className={classes.opacityBackgroundWrapper}>
                    <span style={{color: 'white', fontSize: '16px'}}>AGOTADO</span>
                  </div>
                )}
              </div>
              <Box display="flex" mt={2} pl={4}>
                <Typography variant="h6" className={classes.subtitle}>
                  Fabricante:
                </Typography>
                <Link
                  to={`/b?configure%5Bpage%5D=1&configure%5Bfacets%5D%5B0%5D=category_path_ids&configure%5BfacetFilters%5D%5B0%5D=category_path_ids%3A&configure%5BnumericFilters%5D%5B0%5D=quantity%20>%3D%201&hierarchicalMenu%5Bcategories.lvl0%5D=&refinementList%5Bbrand.name%5D%5B0%5D=${product?.brand?.name}`}
                >
                  {product?.brand?.name}
                </Link>
              </Box>
            </div>
          )}
          {!!product?.discount_price_whit_tax && !product.price_list && (
            <span
              style={{
                textDecoration: 'line-through',
                color: 'rgb(170,170,170)',
              }}
            >
              &nbsp;
              {numeral(getPrice(product?.price_with_tax, product?.price_list?.product_price_list)).format('$0,0')}
              &nbsp;
            </span>
          )}
          <CurrencyFormat
            value={getPrice(
              product?.discount_price_whit_tax || product?.price_with_tax,
              product?.price_list?.product_price_list,
            )}
            displayType={'text'}
            thousandSeparator={true}
            prefix={'$'}
            renderText={(value) => {
              const cal = Math.round(
                product?.price_list?.product_price_list?.price ||
                  ((product?.price_with_tax - product?.discount_price_whit_tax) / product?.price_with_tax) * 100,
              );
              return (
                <Typography variant="body1" color="primary" className={classes.price}>
                  {product?.discount_price_whit_tax && !product.price_list ? (
                    <Badge badgeContent={cal + '%'} color="secondary">
                      ${numeral(value).format('0,0')} &nbsp;&nbsp;
                    </Badge>
                  ) : (
                    <>${numeral(value).format('0,0')} </>
                  )}
                </Typography>
              );
            }}
          />
          {/* <Typography style={{display: 'inline-block', marginBottom: '45px'}} variant="body2" color="textPrimary" className={classes.shipments}>
            Entregas en <Typography style={{display: 'inline-block'}} variant="body2" color="textPrimary" className={classes.shipmentsBold}>Barranquilla</Typography> y <Typography style={{display: 'inline-block'}} variant="body2" color="textPrimary" className={classes.shipmentsBold}>Bogotá</Typography> el mismo día, sí tu pedido se hace antes de las <Typography style={{display: 'inline-block'}} variant="body2" color="textPrimary" className={classes.shipmentsBold}>12pm</Typography>.
          </Typography> */}
          {product?.quantity <= 10 && product?.quantity > 0 && (
            <Typography variant="body2" color="secondary" className={classes.quantity}>
              {`¡Últimas ${product?.quantity} unidades !`}
            </Typography>
          )}
          {product?.quantity > 10 && (
            <Typography variant="body2" className={classes.quantity}>
              {`${product?.quantity} unidades`}
            </Typography>
          )}
          <Typography
            variant="body1"
            color="textPrimary"
            className={classes.text}
            dangerouslySetInnerHTML={{__html: product?.description}}
          />
          {product?.quantity > 0 ? (
            <Box mt={3} className={classes.actions} display="flex" flexDirection="column" gridGap={20}>
              <div style={{position: 'relative'}}>
                <NumericInput
                  value={quantity}
                  min={1}
                  max={product?.quantity}
                  step={1}
                  onChange={handleOnChangeNumeric}
                  precision={0}
                  size={product?.quantity}
                  style={{
                    input: {
                      width: '100%',
                      maxWidth: '150px',
                      height: '100%',
                    },
                  }}
                  mobile
                />
              </div>
              <Box display="flex" alignItems="center" gridGap={20}>
                {product?.status === 'active' ? (
                  <AppButton
                    color="secondary"
                    round
                    disableElevation
                    variant="contained"
                    onClick={handleAddedShoppingCart}
                    className={classes.addedProductButton}
                  >
                    Añadir al carrito
                  </AppButton>
                ) : (
                  <span style={{color: '#ef1719'}}>Producto no disponible</span>
                )}
                {!!user && (
                  <AppButton color="secondary" round disableElevation variant="text" onClick={handleAddFavorite}>
                    {product?.is_favorite ? <FavoriteTwoTone /> : <FavoriteBorder />}
                  </AppButton>
                )}
              </Box>
            </Box>
          ) : (
            <>
              <Box display="flex" alignItems="center" mt={3} className={classes.actions}>
                No hay unidades disponibles
                {!!user && (
                  <AppButton color="secondary" round disableElevation variant="text" onClick={handleAddFavorite}>
                    {product?.is_favorite ? <FavoriteTwoTone /> : <FavoriteBorder />}
                  </AppButton>
                )}
              </Box>
              {product?.quantity <= 0 && (
                <Box display="flex" flexDirection="column">
                  <ModalSubscribeUserProduct
                    product_id={productId}
                    open={openModalSubscribe}
                    onCancel={() => setOpenModalSubscribe(false)}
                  />
                  <Typography>¿Lo necesitas? Te lo conseguimos</Typography>
                  <AppButton
                    style={{marginTop: 10}}
                    color="secondary"
                    round
                    disableElevation
                    variant="contained"
                    onClick={handleOpenSubscribeProduct}
                  >
                    Notificar Disponibilidad
                  </AppButton>
                </Box>
              )}
            </>
          )}
        </Grid>
      </Grid>
      <Box my={3}>
        <Divider />
      </Box>
      <Box mt={5} mb={3} className={classes.rootTabs}>
        <Box mb={3}>
          <Tabs
            value={activeTab}
            onChange={(_, index) => setActiveTab(index)}
            variant="scrollable"
            scrollButtons="auto"
            background="secondary"
          >
            {/* <Tab className={classes.tabSelected} label="Especificaciones" />
            <Tab className={classes.tabSelected} label="Calificación" /> */}
          </Tabs>
        </Box>
        <Box className={classes.tabPanelWrapper}>
          {/* <TabPanel value={activeTab} index={0}>
            <Box mb={3} clone>
              <Typography variant="h3" align="center" className={classes.helpText}>
                Especificaciones del producto
              </Typography>
            </Box>
            <ProductSpecifications data={product} />
          </TabPanel> */}
          <TabPanel value={activeTab} index={1}>
            <Box mb={3} clone>
              <Typography variant="h3" align="center" className={classes.helpText}>
                Calificaciones de nuestros clientes
              </Typography>
            </Box>
            <ProductReviews product={product || {}} />
          </TabPanel>
        </Box>
      </Box>
      <Box mb={3} clone>
        <Typography variant="h3" align="center" className={classes.helpText}>
          También te puede interesar
        </Typography>
      </Box>
      <ProductsInterest currentProductId={product?.id} categoryId={product?.category_id} />
    </Container>
  );
}

export default Product;
